import classnames from 'classnames';
import React from 'react';

import { Row } from '@xingternal/xing-grid';

import ErrorBoundary from '@/components/error-boundary';

import styles from './job-posting-module.css';

interface Props {
  className?: string;
  testId?: string;
  dataCy?: string;
  children: React.ReactNode;
}

export const JobPostingModule: React.FC<Props> = ({ children, className, testId, dataCy, ...otherProps }) => {
  return (
    <ErrorBoundary FallbackComponent={null}>
      <Row
        className={classnames(styles.module, styles.noBorder, className)}
        data-testid={testId}
        data-cy={dataCy}
        {...otherProps}
      >
        {children}
      </Row>
    </ErrorBoundary>
  );
};
